import { searchCancelationReport } from "apis";
import { DataTable } from "components/commons";
import { VenueContext } from "contexts";
import { useApi, useMount, useModal,useFilter } from "hooks";
import React, {useContext, useMemo, useCallback } from "react";
import { HeaderA } from "components/headers";
import { CancelationReportColumns } from "./columns";
import lang from "translations";
import { ModuleWrapper } from "components/fragments";
import { formatDate } from "services";
import { DateTime } from "enums";
import CancelTicketModal from "components/modals/cancel-ticket-modal/cancel-ticket-modal";

const CancelationReport = () => {
  const { venue } = useContext(VenueContext);
  const cancelTicketModal = useModal();
  
  const defaultFilter = {
    venueId : venue.venueId,
    page: 1,
    pageSize: 20,
  };

   const { modifyFilters, filterState } = useFilter(
    defaultFilter
  );

  const {
    request: searchCancelationReportRequest,
    loading: loadingCancelationReports,
    result: searchCancelationReportResult
  } = useApi({
    api: searchCancelationReport,
    isArray: true,
  });

  useMount(() => {
    searchCancelationReportRequest(filterState);
  });

    const fetchList = useCallback(
      async (requestState) => {
        searchCancelationReportRequest(requestState);
      },
      [searchCancelationReportRequest]
    );

  const noResult = useMemo(() => {
    return (
      <div className="pt-lg">
        <p className="text-xl text-gray-600">{lang.noReportsFound}</p>
        <p className="text-md text-gray-400">{lang.weDidNotFoundReports}</p>
      </div>
    );
  }, []);

  const CancelationReportsData = useMemo(() => {
    return searchCancelationReportResult?.data?.data?.map(
      ({
        id,
        bookingId,
        externalTicketId,
        reason,
        createdAt
      }) => {
        return {
          id,
          bookingId,
          // bookingId :<ButtonLink
          //       className="cursor-pointer whitespace-nowrap text-blue"
          //       path={Path.BOOKING_ID(bookingId)}
          //     >
          //       {bookingId}
          //     </ButtonLink>,
          externalTicketId,
          reason,
          createdAt: formatDate(createdAt, DateTime.DDMMYYYY_HHMM)
        };
      }
    );
  }, [searchCancelationReportResult]);


  const showCancelTicketModal = useCallback(() => {
      cancelTicketModal.show({
        title: lang.addAccount,
        primaryText: lang.banTag,
        initialState: undefined,
        isEdit: false,
        save: () => {
        },
      });
    }, [cancelTicketModal]);

  return (
    <ModuleWrapper>
      <HeaderA
        title={lang.cancelationReport}
        description={lang.cancelationReportDesc}
        className="mb-md"
        button={{
                  text: lang.cancelTicket,
                  onClick: () => {
                    showCancelTicketModal();
                  },
                }}
      />


      {searchCancelationReportResult?.data?.data?.length > 0 ? (
        
        <DataTable
          loading={loadingCancelationReports}
          columns={CancelationReportColumns}
          data={CancelationReportsData}
          pageable={true}
          onChangePage={modifyFilters}
          page={filterState.page}
          pageSize={filterState.pageSize}
          total={searchCancelationReportResult?.metadata?.total}
          fetchList={fetchList}
        />

      ) : (
        noResult
      )}

       <CancelTicketModal
        {...cancelTicketModal}
        onTicketCancelled={() => {
          cancelTicketModal.close();
          searchCancelationReportRequest();
        }}
      />
    </ModuleWrapper>
  );
};

export default CancelationReport;
